export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "plot-analysis",
    name: "剧情解析",
    description: "深入剖析电影情节脉络，解读每个关键场景的叙事意义",
    icon: "ri-movie-line",
  },
  {
    slug: "reviews",
    name: "观后感",
    description: "来自不同观众的观影感悟与情感共鸣",
    icon: "ri-heart-line",
  },
  {
    slug: "education",
    name: "教育意义",
    description: "探讨电影蕴含的教育理念与学习方法启示",
    icon: "ri-book-open-line",
  },
  {
    slug: "character-analysis",
    name: "角色分析",
    description: "深度解读主要角色的性格特征与成长轨迹",
    icon: "ri-user-star-line",
  },
  {
    slug: "spelling-bee",
    name: "拼写比赛",
    description: "了解拼字大赛的文化背景与比赛机制",
    icon: "ri-chat-1-line",
  },
  {
    slug: "inspiration",
    name: "励志成长",
    description: "电影带来的心灵触动与成长启发",
    icon: "ri-rocket-line",
  },
];